//# sourceMappingURL=analytics.mjs.map
/// <reference types="./analytics.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $metrics from "../../../data_types/data/metrics.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_analytics() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["dashboard", "curve"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.expect(
            _pipe$1,
            $decode.list($metrics.metrics_curve_decoder()),
          );
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (m) => {
              dispatch(new $msg.Dashboard(new $msg.ApiReturnedAnalytics(m)));
              return undefined;
            },
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}

export function fetch_metrics() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["dashboard", "metrics"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.expect(
            _pipe$1,
            $decode.list($metrics.metric_group_decoder()),
          );
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (m) => {
              dispatch(new $msg.Dashboard(new $msg.ApiReturnedMetrics(m)));
              return undefined;
            },
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}
